import _ from 'underscore';
import jQuery from 'jquery';
import Backbone from 'backbone';
import Localizer from 'localizer';
import viewerSocialProfile from 'models/user/ViewerSocialProfile';
import MyLastUsedDevice from 'models/device/MyLastUsedDevice';
import MainContainerView from 'views/main/MainContainer/MainContainerView';
import ToolTipView from 'views/utils/ToolTipView';
import ErrorToolTipView from 'views/utils/ErrorToolTipView';
import PageContainerView from 'containers/fullpage/PageContainer';
import EmbedContainerView from 'embed/EmbedContainer';
import Loadable from 'utils/extensions/Loadable';
import NavigationUtil from 'utils/NavigationUtil';
import AnalyticsUtil from 'utils/AnalyticsUtil';
import MainNavUtil from 'utils/MainNavUtil';
import ViewerUserPreferences from 'models/user/ViewerUserPreferences';
import { pushUserEngagement } from 'utils/UserEngagement';
import { gcApi } from 'config/axios';

// Unused Imports
import UserPreference from 'models/user/UserPreference';
import UserExperienceModalPopupView from 'views/user/UserExperienceModalPopupView';
import ModelSynchronizer from 'utils/ModelSynchronizer';

Backbone.emulateHTTP = true;

var modals = [];
var vPageView;

var MainRouter = Backbone.Router.extend({
    initialize: function(args) {
        if (!args.userPreferences) {
            throw 'MainRouter: userPreferences required.';
        }

        this.userPreferences = args.userPreferences;
        this.displayName = this.userPreferences.get('displayName');
        this.urlBustValue = args.urlBustValue;

        // check china mode parameter
        var queryString = window.location.search;
        if (queryString.length > 0) {
            var urlParams = new URLSearchParams(queryString);
            window.chinaMode = urlParams.get('chinaMode');
        }

        this.viewerIsAuthenticated = false;

        if (!viewerSocialProfile.get('profileId')) {
            this.userPreferences.getLocaleFromCookie = true;
        } else {
            this.viewerIsAuthenticated = true;
            this.userPreferences.setPreferenceKey(viewerSocialProfile.get('profileId'));
            this.userPreferences.viewerIsAuthenticated = true;
        }

        Localizer.setUrlBustingParam(this.urlBustValue);

        var documentElement = jQuery('body');

        this.setDefaultUserRoles();

        this.mainContainerView = new MainContainerView({
            model: this.userPreferences,
            el: documentElement,
            contextPath: args.contextPath,
            viewerIsAuthenticated: args.viewerIsAuthenticated,
            userProfile: args.userProfile,
            userPreferences: this.userPreferences,
            gAuthHost: args.gAuthHost,
            sessionLength: args.sessionLength,
            isError: typeof window.ERROR_VIEW !== 'undefined' && window.ERROR_VIEW !== null
        });

        this.mainContainerView.bind(
            MainContainerView.Events.UNAUTHENTICATED_RENDER_COMPLETE,
            function() {
                documentElement.find('#light_box_fade').remove(); //remove unnecessary div
            },
            this
        );
        this.mainContainerView.load();

        this.bind('route', function(route, args) {
            var url = NavigationUtil.getHostUrl() + NavigationUtil.url('/' + [route].concat(args).join('/'));
            AnalyticsUtil.push({
                event: 'track_pageview',
                category: window.location.href,
                action: document.title
            });
            if (window.ADRUM) {
                vPageView = new window.ADRUM.events.VPageView({
                    url: window.location.href
                });
                vPageView.start();
            }
        });

        this.setLastUsedDeviceAplicationKeyGlobalVariable();
    },

    routes: {
        'dashboard/:dashboardId': 'dashboard',
        '': 'dashboard',
        '*notFound': 'getResourceNotFoundRoute'
    },

    onSSOSessionExpired: function() {
        // SSO Session is expired.  Reload will send the user to the sign-in page.
        location.reload();
    },

    isErrorPage: function() {
        return ERROR_VIEW != null;
    },

    loadErrorPageView: function() {
        switch (ERROR_VIEW) {
            case 'resourceNotFoundRoute':
                this.getResourceNotFoundRoute();
                break;
            case 'NoPrivilegesPageView':
                this.getNoPrivilegesPageView();
                break;
            case 'RegistrationExceptions':
                this.getRegistrationExceptionPageView();
                break;
            case 'FailedDependencies':
                this.getFailedDependenciesPageView();
                break;
        }
    },

    getFailedDependenciesPageView: function() {
        var _this = this;
        import('pages/dependencies/FailedDependenciesPageView').then(({ default: FailedDependenciesPageView }) => {
            var view = new FailedDependenciesPageView({
                userPreferences: _this.userPreferences
            });

            _this.displayPage(view);
        });
    },

    getRegistrationExceptionPageView: function() {
        var _this = this;
        import('pages/registration_exceptions/RegistrationExceptionsPageView').then(
            ({ default: RegistrationExceptionsPageView }) => {
                var view = new RegistrationExceptionsPageView({
                    id: new Date().getTime(),
                    userPreferences: ViewerUserPreferences
                });

                _this.displayPage(view, true);
            }
        );
    },

    getNoPrivilegesPageView: function() {
        var _this = this;
        import('pages/privileges/NoPrivilegesPageView').then(({ default: NoPrivilegesPageView }) => {
            var typeKey = '';
            var pageType = '';

            if (window.location.href.indexOf('/activity/') > -1) {
                typeKey = 'privileges.activity';
                pageType = 'activity';
            } else if (window.location.href.indexOf('/course/') > -1) {
                typeKey = 'privileges.course';
            } else if (window.location.href.indexOf('/newspost/') > -1) {
                typeKey = 'privileges.post';
            } else if (window.location.href.indexOf('/swing-analysis/') > -1) {
                typeKey = 'privileges.swing.analysis';
            }

            var view = new NoPrivilegesPageView({
                userPreferences: ViewerUserPreferences,
                id: new Date().getTime(),
                authTypeKey: typeKey,
                viewerIsAuthenticated: _this.viewerIsAuthenticated,
                pageType
            });

            ERROR_VIEW = null;

            _this.displayPage(view, true);
        });
    },

    getResourceNotFoundRoute: function() {
        var _this = this;
        import('pages/resource_not_found/ResourceNotFound').then(({ default: ResourceNotFoundView }) => {
            var pageType = '';
            if (window.location.href.indexOf('/activity/') > -1) {
                pageType = 'activity';
            }
            var view = new ResourceNotFoundView({
                userPreferences: _this.userPreferences,
                displayName: _this.displayName,
                pageType
            });

            ERROR_VIEW = null;

            _this.displayPage(view, true);
        });
    },

    /**
     * Used in place of displayPage to display embed pages
     * @param {*} pageView - embed page to display
     */
    displayEmbed: function(pageView) {
        const displayErrorPage = typeof handled === 'undefined' && this.isErrorPage();

        if (displayErrorPage) {
            this.loadErrorPageView();
        } else if (!this.embedContainerView) {
            pageView.once(
                Loadable.Loadable.Events.ON_DEPENDENCIES_LOADED,
                function() {
                    this.embedContainerView = new EmbedContainerView({
                        model: this.userPreferences,
                        el: jQuery('.embed-container')
                    });

                    this.embedContainerView.setPageView(pageView);
                },
                this
            );
        } else {
            this.embedContainerView.setPageView(pageView);
        }

        if (pageView.run) pageView.run();
        else if (pageView.load) pageView.load();
        else this.loadErrorPageView();
    },

    displayPage: function(pageView, handled) {
        pushUserEngagement();

        // Close all modals
        this.closeModals();

        // Hide all orphaned tooltips
        ToolTipView.hideAll();
        ErrorToolTipView.hideAll();

        if (window.ADRUM && vPageView) {
            pageView.once(Loadable.Loadable.Events.ON_DEPENDENCIES_LOADED, function() {
                vPageView.end();
                window.ADRUM.report(vPageView);
            });
        }

        // we have special error handlings for group pages, so don't display general errors for group pages
        var displayErrorPage = typeof handled === 'undefined' && this.isErrorPage();

        if (displayErrorPage && window.location.href.includes('/group/')) {
            // For group error pages, we intend to display the customized React ones, which are rendered by GroupGenesisState.jsx, so skip the default error page here
            displayErrorPage = false;
            // We should also reset the ERROR_VIEW, otherwise the default error page would be displayed on whatever the next route is
            ERROR_VIEW = null;
        }

        if (displayErrorPage) {
            this.loadErrorPageView();
        } else if (!this.pageContainerView) {
            pageView.once(
                Loadable.Loadable.Events.ON_DEPENDENCIES_LOADED,
                function() {
                    this.removeExistingView();

                    this.pageContainerView = new PageContainerView({
                        model: this.userPreferences,
                        el: jQuery('.content')
                    });

                    this.pageContainerView.setPageView(pageView);

                    this.pageContainerView.registerApplicationEvent('RELOAD_DEVICES_POPUP_MENU', this, function() {
                        this.mainContainerView.topHeader.devicePopupMenuView.load();
                    });

                    this.pageContainerView.registerApplicationEvent('SHOW_WAIT_CURSOR', this, this.showWaitCursor);
                    this.pageContainerView.registerApplicationEvent('HIDE_WAIT_CURSOR', this, this.hideWaitCursor);
                },
                this
            );
        } else {
            this.pageContainerView.setPageView(pageView);
        }

        if (!displayErrorPage) {
            pageView.once(
                Loadable.Loadable.Events.ON_DEPENDENCIES_LOAD_FAILED,
                function(response) {
                    if (this.isForbidden(response)) {
                        this.getNoPrivilegesPageView();
                    }

                    if (this.isBadRequest(response) || this.isNotFound(response) || this.isServerError(response)) {
                        this.getFailedDependenciesPageView();
                    }
                },
                this
            );
        } else {
            if (!this.pageContainerView) {
                this.pageContainerView = new PageContainerView({
                    model: this.userPreferences,
                    el: jQuery('.content')
                });
            }
        }

        if (!displayErrorPage) {
            this.showWaitCursor();
            pageView.load();
        }
    },

    isBadRequest: function(response) {
        return response.status === 400;
    },

    isServerError: function(response) {
        return response.status >= 500;
    },

    isNotFound: function(response) {
        return response.status === 404;
    },

    isForbidden: function(response) {
        return response.status === 403;
    },

    showWaitCursor: function() {
        jQuery('body').addClass('wait');
    },

    hideWaitCursor: function() {
        jQuery('body').removeClass('wait');
    },

    setDefaultUserRoles: function() {
        const that = this;
        const defaultUserRoles = ['ROLE_WELLNESS_USER', 'ROLE_FITNESS_USER'];
        const viewerSocialProfileRoles = viewerSocialProfile.get('userRoles');

        if (viewerSocialProfileRoles && defaultUserRoles.some((role) => !viewerSocialProfileRoles.includes(role))) {
            gcApi.post('/dashboard-service/userExperience', defaultUserRoles).then(() => {
                that.refreshUserSession();
            });
        }
    },

    refreshUserSession: function() {
        $.post('/modern/refreshUserSession').always(function() {
            const roles = viewerSocialProfile.get('userRoles');
            const defaultUserRoles = ['ROLE_WELLNESS_USER', 'ROLE_FITNESS_USER'];
            viewerSocialProfile.set('userRoles', _.union(roles, defaultUserRoles));
        });
    },

    dashboard: function(dashboardId) {
        pushUserEngagement();
        if (viewerSocialProfile.isRaceEventProvider()) {
            Backbone.history.navigate('/calendar', { trigger: true });
            return;
        }

        // Redirect to GC5 home page
        var redirectHomePage = function() {
            Backbone.history.navigate('/home', {
                trigger: true
            });
            return;
        };

        // CA-5690 - Dashboard is not loaded if url contains query string
        // Checking whether or not the given parameter is a number (a dashboard id)
        // If not, it means the dashboardId variable contains the value of the provided query string
        // (as per Backbone v1.3.3), which causes the dashboard to not load correctly.
        if (!parseInt(dashboardId, 10)) {
            dashboardId = null;
        }

        // Close all modals
        this.closeModals();

        // Hide all orphaned tooltips
        ToolTipView.hideAll();
        ErrorToolTipView.hideAll();

        // Check if we got here because of the registration exceptions page.
        if (this.isErrorPage()) {
            this.loadErrorPageView();
        } else {
            // All users are now redirected to the GC5 Homepage
            redirectHomePage();
        }
    },

    removeExistingView: function() {
        jQuery('.content').replaceWith('<div class="content clearfix"></div>');

        MainNavUtil.activeDashboardId = null;

        if (this.pageContainerView) {
            this.pageContainerView.onContainerUnloaded();
            this.pageContainerView = null;
        }
    },

    index: function() {
        alert('default');
    },

    /**
     * Called when the FullPageContainer has successfully loaded its dependencies (minus the page itself).
     */
    onPageContainerDependenciesLoaded: function() {},

    /**
     * Raises an application event with the given name. Any extra argument provided will be provided
     * to the callback. Will notify any widget that has registered for the event. Page support will be
     * added at a later time.
     *
     * @param originator the object that triggered the event.
     * @param eventName the applicationEvent name (Ex. 'ACTIVITY_ADDED').
     *
     */
    raiseApplicationEvent: function(originator, eventName) {
        if (this.pageContainerView) {
            this.pageContainerView.raiseApplicationEvent.apply(this.pageContainerView, arguments);
        }
    },
    /**
     * Need to set global variable with last used device application key for Google Analytics
     * see GCPLAN-12059
     */
    setLastUsedDeviceAplicationKeyGlobalVariable: function() {
        if (this.viewerIsAuthenticated && _.isUndefined(window.lastUsedDeviceApplicationKey)) {
            var lastUsedDeviceInfo = new MyLastUsedDevice().fetch({
                success: function(model) {
                    window.lastUsedDeviceApplicationKey = model.get('lastUsedDeviceApplicationKey');
                }
            });
        }
    },

    registerModal: function(modal) {
        modals.push(modal);
    },

    closeModals: function() {
        _.each(modals, function(modal) {
            if (modal && typeof modal.close === 'function') {
                modal.close();
            }
        });
    },

    displayNoPrivilegesPage: function() {
        this.getNoPrivilegesPageView();
    },

    displayPageNotFoundPage: function() {
        this.getResourceNotFoundRoute();
    },

    displayFailedDepenciesPage: function() {
        this.getFailedDependenciesPageView();
    }
});

export default MainRouter;
